// extracted by mini-css-extract-plugin
export default {"titleText":"ArtistDataCell_titleText__EleJ7","numberText":"ArtistDataCell_numberText__5QLhE"};